module.exports = __webpack_public_path__ + "2afd0c92a07c4a1dc9b5d52618d64a2e.jpg";